export class ConfettiOptions {
    constructor() {
        this.angle = 90;
        this.count = 50;
        this.spread = 45;
        this.startVelocity = 45;
        this.decay = 0.9;
        this.gravity = 1;
        this.drift = 0;
        this.ticks = 200;
        this.position = {
            x: 50,
            y: 50,
        };
        this.colors = ["#ffffff", "#ff0000"];
        this.shapes = ["square", "circle"];
        this.scalar = 1;
        this.zIndex = 100;
        this.disableForReducedMotion = true;
    }
    get particleCount() {
        return this.count;
    }
    set particleCount(value) {
        this.count = value;
    }
    get origin() {
        return {
            x: this.position.x / 100,
            y: this.position.y / 100,
        };
    }
    set origin(value) {
        this.position.x = value.x * 100;
        this.position.y = value.y * 100;
    }
    load(data) {
        var _a, _b;
        if (!data) {
            return;
        }
        if (data.angle !== undefined) {
            this.angle = data.angle;
        }
        const count = (_a = data.count) !== null && _a !== void 0 ? _a : data.particleCount;
        if (count !== undefined) {
            this.count = count;
        }
        if (data.spread !== undefined) {
            this.spread = data.spread;
        }
        if (data.startVelocity !== undefined) {
            this.startVelocity = data.startVelocity;
        }
        if (data.decay !== undefined) {
            this.decay = data.decay;
        }
        if (data.gravity !== undefined) {
            this.gravity = data.gravity;
        }
        if (data.drift !== undefined) {
            this.drift = data.drift;
        }
        if (data.ticks !== undefined) {
            this.ticks = data.ticks;
        }
        const position = (_b = data.position) !== null && _b !== void 0 ? _b : this.position;
        if ((position === null || position === void 0 ? void 0 : position.x) !== undefined) {
            this.position.x = position.x;
        }
        if ((position === null || position === void 0 ? void 0 : position.y) !== undefined) {
            this.position.y = position.y;
        }
        if (data.colors !== undefined) {
            if (data.colors instanceof Array) {
                this.colors = [...data.colors];
            }
            else {
                this.colors = data.colors;
            }
        }
        if (data.shapes !== undefined) {
            if (data.shapes instanceof Array) {
                this.shapes = [...data.shapes];
            }
            else {
                this.shapes = data.shapes;
            }
        }
        if (data.scalar !== undefined) {
            this.scalar = data.scalar;
        }
        if (data.zIndex !== undefined) {
            this.zIndex = data.zIndex;
        }
        if (data.disableForReducedMotion !== undefined) {
            this.disableForReducedMotion = data.disableForReducedMotion;
        }
    }
}
